module.exports = __webpack_public_path__ + "img/1.e27d3c9e.jpg";